import React, { useEffect, useState } from 'react'
import Submenu from '../../UI/menu/submenu/Submenu'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const SubmenuUser = () => {

    const [list, setList] = useState([])

    useEffect(() => {
        setMenu()
    }, [])

    const setMenu = () => {
        const listTemp = []

        listTemp.push({
            url: '/user/work-place',
            name: 'Робоче місце',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })

        listTemp.push({
            url: '/user/settings',
            name: 'Налаштування',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })

        listTemp.push({
            url: '/user/info',
            name: 'Інформація',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })

        setList(listTemp)
    }
    
  return (
    <Submenu 
        list={list}
    />
  )
}

export default SubmenuUser